import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ControlSelect, ControlText } from "../../../common/custom-form/control-field.component";
import { accessInformationActions } from "../../../../store/external/inventory/details-view/access-information.reducer";
import { REQUEST_TYPES_ID } from "../../../../constants/external-constants";
import { TRANSLATIONS as translation } from '../../../../utils/constant.utils';
import { isDisabledPerRequestType } from '../../../../utils/helpers.utils';
import { CustomDropdown } from "../../../common/custom-form/custom-dropdown.component";
import CustomSearchableDropdownWrapper from "../../../common/custom-form/custom-dropdown/custom-searchable-dropdown-wrapper";

class AccessInformation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeDropdown: false
        }
    }

    componentDidMount() {
        const {fetchAccessData, circuitOrderAccessForm} = this.props;
        if (typeof fetchAccessData === 'function') {
            fetchAccessData(circuitOrderAccessForm)
        }       
    }
    searchableChange(event, model) {
        this.props.changeFormModel(model, event.key);
    }

    toggleActiveState = () => {
        const { isCircuitOrder, requestTypeId } = this.props;
        const noAddFunction = isCircuitOrder && parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.subscriptionCancellation) || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.portOut);

        if (isCircuitOrder && this.hasExistingSimList() && noAddFunction) {
            this.setState({ activeDropdown: false });
        }
        else {
            this.setState(prevState => ({ activeDropdown: !prevState.activeDropdown }));
        }
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '')
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    }   

    modelValue = (key, isString) => {
        const {inventoryCircuitForm,circuitOrderAccessForm,isInventoryCircuit} = this.props;

        var value = isInventoryCircuit ? inventoryCircuitForm.accessInformation[key] : circuitOrderAccessForm[key];

        return (value !== null ? value : (isString ? '' : null))
    }
    handleAccessBandwidthSearch = (query) => {
        this.props.getAccessBandwidth(1, query);
    }

    loadMoreAccessBandwidth = (searchString) => {
        const { accessBandwidthPage } = this.props;
        this.props.getAccessBandwidth(accessBandwidthPage + 1, searchString);
    }

    handleElectricalOpticalInterfaceSearch = (query) => {
        this.props.getElectricalOpticalInterface(1, query);
    }

    loadMoreElectricalOpticalInterface = (searchString) => {
        const { electricalOpticalInterfacePage } = this.props;
        this.props.getElectricalOpticalInterface(electricalOpticalInterfacePage + 1, searchString);
    }

    handleServiceClassSearch = (query) => {
        this.props.getServiceClass(1, query);
    }

    loadMoreServiceClass = (searchString) => {
        const { serviceClassPage } = this.props;
        this.props.getServiceClass(serviceClassPage + 1, searchString);
    }
    render() {
        const {
            accessOptions,
            accessBandwidthOptions,
            electircalOpticalInterfaceOptions,
            serviceClassOptions,
            siteSurveyRequestedOptions,
            isCoordinatedServiceOptions,
            requiredLOACFAOptions,
            requestTypeId,
            formModel,
            completed,
            hasMoreAccessBandwidth,
            isAccessBandwidthLoading,
            hasMoreElectricalOpticalInterface,
            isElectricalOpticalInterfaceLoading,
            hasMoreServiceClass,
            isServiceClassLoading,
            formName,
            isInventoryCircuit } = this.props;

        return (
            <CustomDropdown label={`${this.toLocaleLanguage('access_information')}`} activeDropdown={this.state.activeDropdown} toggleActiveState={this.toggleActiveState} >
                <div className="details-4-col-container add-sim-container detail-view__container">
                    <ControlSelect
                        model={`${formModel}.siteSurveyRequested`}
                        label={`${this.toLocaleLanguage('site_survey_requested_caps')}`}
                        placeholder="Select..."
                        options={siteSurveyRequestedOptions}
                        className="form-select"
                        value={`${this.modelValue('siteSurveyRequested', false)}`}   
                        disabled={completed || isDisabledPerRequestType(requestTypeId, 'siteSurveyRequested')}
                    />
                    <CustomSearchableDropdownWrapper
                        label={`${this.toLocaleLanguage('access_bandwidth_caps')}`}
                        options={accessBandwidthOptions}
                        selected={isInventoryCircuit ? (this.props[formName]?.accessInformation?.accessBandwidth ?? "") : (this.props[formModel].accessBandwidth ?? "")}
                        onChange={(e) => this.searchableChange(e, `${formModel}.accessBandwidth`)}
                        placeholder="Select..."
                        fieldProp={`${formModel}.accessBandwidth`}
                        tagName='accessBandwidth'
                        optionLabelKey={{
                            Key: 'FilterId',
                            Value: 'FilterName'
                        }}
                        disabled={completed || isDisabledPerRequestType(requestTypeId, 'accessBandwidth')}
                        onSearchChange={this.handleAccessBandwidthSearch}
                        onLoadMore={this.loadMoreAccessBandwidth}
                        isLoading={isAccessBandwidthLoading}
                        hasMore={hasMoreAccessBandwidth}
                    />
                    <ControlSelect
                        model={`${formModel}.access`}
                        label={`${this.toLocaleLanguage('access_caps')}`}
                        placeholder="Select..."
                        options={accessOptions}
                        className="form-select"
                        value={`${this.modelValue('access', false)}`}
                        disabled={completed || isDisabledPerRequestType(requestTypeId, 'access')}
                    /> 
                    <ControlText
                        model={`${formModel}.existingCircuitID`}
                        label={`${this.toLocaleLanguage('existing_circuit_id_caps')}`}
                        placeholder="Enter text here..."
                        className="form-control"
                        customClass="remove-left__indent"
                        value={`${this.modelValue('existingCircuitID', true)}`}
                        disabled={completed || isDisabledPerRequestType(requestTypeId, 'existingCircuitID')}
                    />
                    <ControlSelect
                        model={`${formModel}.isCoordinatedService`}
                        label={`${this.toLocaleLanguage('is_this_coordinated_services_caps')}`}
                        placeholder="Select..."
                        options={isCoordinatedServiceOptions}
                        className="form-select"
                        customClass="remove-left__indent"
                        value={`${this.modelValue('isCoordinatedService', false)}`}
                        disabled={completed || isDisabledPerRequestType(requestTypeId, 'isCoordinatedService')}
                    /> 
                    <CustomSearchableDropdownWrapper
                        label={`${this.toLocaleLanguage('electrical_optical_interface_caps')}`}
                        options={electircalOpticalInterfaceOptions}
                        selected={isInventoryCircuit ? (this.props[formName]?.accessInformation?.electricalOpticalInterface ?? "") : (this.props[formModel].electricalOpticalInterface ?? "")}
                        onChange={(e) => this.searchableChange(e, `${formModel}.electricalOpticalInterface`)}
                        placeholder="Select..."
                        fieldProp={`${formModel}.electricalOpticalInterface`}
                        tagName='electricalOpticalInterface'
                        optionLabelKey={{
                            Key: 'FilterId',
                            Value: 'FilterName'
                        }}
                        disabled={completed || isDisabledPerRequestType(requestTypeId, 'electricalOpticalInterface')}
                        onSearchChange={this.handleElectricalOpticalInterfaceSearch}
                        onLoadMore={this.loadMoreElectricalOpticalInterface}
                        isLoading={isElectricalOpticalInterfaceLoading}
                        hasMore={hasMoreElectricalOpticalInterface}
                    />
                    <ControlSelect
                        model={`${formModel}.requiredLOACFA`}
                        label={`${this.toLocaleLanguage('required_loa_cfa_caps')}`}
                        placeholder="Select..."
                        options={requiredLOACFAOptions}
                        value={`${this.modelValue('requiredLOACFA', false)}`}
                        className="form-select"
                        disabled={completed || isDisabledPerRequestType(requestTypeId, 'requiredLOACFA')}
                    /> 
                    <ControlText
                        model={`${formModel}.accessPortCIR`}
                        label={`${this.toLocaleLanguage('access_port_cir_caps')}`}
                        placeholder="Enter text here..."
                        className="form-control"
                        customClass="remove-left__indent"
                        value={`${this.modelValue('accessPortCIR', true)}`}
                        disabled={completed || isDisabledPerRequestType(requestTypeId, 'accessPortCIR')}
                    />
                    <ControlText
                        model={`${formModel}.DLCI`}
                        label={`${this.toLocaleLanguage('dlci_caps')}`}
                        placeholder="Enter text here..."
                        className="form-control"
                        value={`${this.modelValue('DLCI', true)}`}
                        disabled={completed || isDisabledPerRequestType(requestTypeId, 'DLCI')}
                    />
                    <CustomSearchableDropdownWrapper
                        label={`${this.toLocaleLanguage('service_class_caps')}`}
                        options={serviceClassOptions}
                        selected={isInventoryCircuit ? (this.props[formName]?.accessInformation?.serviceClass ?? "") : (this.props[formModel].serviceClass ?? "" )}
                        onChange={(e) => this.searchableChange(e, `${formModel}.serviceClass`)}
                        placeholder="Select..."
                        fieldProp={`${formModel}.serviceClass`}
                        tagName='serviceClass'
                        optionLabelKey={{
                            Key: 'FilterId',
                            Value: 'FilterName'
                        }}
                        disabled={completed || isDisabledPerRequestType(requestTypeId, 'serviceClass')}
                        onSearchChange={this.handleServiceClassSearch}
                        onLoadMore={this.loadMoreServiceClass}
                        isLoading={isServiceClassLoading}
                        hasMore={hasMoreServiceClass}
                    />
                    <ControlText
                        model={`${formModel}.uploadSpeed`}
                        label={`${this.toLocaleLanguage('upload_speed_caps')}`}
                        placeholder="Enter text here..."
                        className="form-control"
                        value={`${this.modelValue('uploadSpeed', true)}`}
                        disabled={completed || isDisabledPerRequestType(requestTypeId, 'uploadSpeed')}

                    />
                    <ControlText
                        model={`${formModel}.downloadSpeed`}
                        label={`${this.toLocaleLanguage('download_speed_caps')}`}
                        placeholder="Enter text here..."
                        className="form-control"
                        customClass="remove-left__indent"
                        value={`${this.modelValue('downloadSpeed', true)}`}
                        disabled={completed || isDisabledPerRequestType(requestTypeId, 'downloadSpeed')}
                    />
                    <ControlText
                        model={`${formModel}.requestedIP`}
                        label={`${this.toLocaleLanguage('requested_ip_caps')}`}
                        placeholder="Enter text here..."
                        className="form-control"
                        value={`${this.modelValue('requestedIP', true)}`}
                        disabled={completed || isDisabledPerRequestType(requestTypeId, 'requestedIP')}
                    />
                    <ControlText
                        model={`${formModel}.handsOffType`}
                        label={`${this.toLocaleLanguage('hands_off_type_caps')}`}
                        placeholder="Enter text here..."
                        className="form-control"
                        value={`${this.modelValue('handsOffType', true)}`}
                        disabled={completed || isDisabledPerRequestType(requestTypeId, 'handsOffType')}
                    />
                </div>
            </CustomDropdown>
        )
    }
}

export default connect(
    state => {
        const { inventoryCircuitAccessInformation, circuitOrderAccessInformation, translation } = state;
        const { inventoryCircuitForm, circuitOrderForm, circuitOrderAccessForm } = state.form;
        return {
            ...inventoryCircuitAccessInformation,
            ...circuitOrderAccessInformation,
            ...translation,
            inventoryCircuitForm,
            circuitOrderForm,
            circuitOrderAccessForm
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, accessInformationActions),
        dispatch
    )
)(AccessInformation);